import React, { forwardRef, ReactNode, useState } from 'react';
import styles from './styles.module.scss';

// import RenderHelpBox from '@/components/common/RenderHelpBox';
import Checkbox from '../CheckBox';
import RenderHelpBox from '../RenderHelpBox';
interface CheckBoxItem {
  checked?: boolean;
  title?: string | null;
}
interface checkBoxProps {
  className?: string;
  extraWrapperClass?: string;
  wrapper?: string;
  prefix?: ReactNode;
  prefixClass?: string;
  affix?: ReactNode;
  affixStyle?: string;
  onChange?: any;
  affixWrapper?: string;
  showError?: boolean;
  error?: string;
  title?: string | null;
  extraInfoStyle?: string;
  extraInfo?: string;
  disabled?: boolean;
  value?: CheckBoxItem[];
  showRemoveIcon?: boolean;
  guide?: string;
  inputType?: string;
  child?: ReactNode;
  vertical?: boolean;
  multi?: boolean;
  // list?:CheckBoxItem[]
}

const AppCheckBoxGroup = forwardRef<HTMLInputElement, checkBoxProps>((props, ref) => {
  const {
    extraWrapperClass,
    wrapper,
    prefix,
    prefixClass,
    affix,
    affixWrapper = '',
    showError,
    error = '',
    title = null,
    extraInfoStyle = '',
    extraInfo = '',
    disabled = false,
    value = [],
    showRemoveIcon = true,
    guide,
    vertical = true,
    onChange,
    multi = false,
  } = props;
  const [focused, setFocused] = useState('');
  console.log('focused==', focused);
  console.log('disabled==', disabled);
  const onChangeCheckBox = (x: CheckBoxItem, j: number) => {
    let newarray = [...value];
    if (!multi) {
      newarray?.map((x, k) => {
        newarray[k].checked = false;
      });
    }
    newarray[j].checked = !newarray[j].checked;
    onChange(newarray);
  };
  return (
    <div
      className={`formItem ${styles.wrapperContainer} relative ${disabled && styles.disabled} ${!vertical && 'horizontalFormItem'} ${extraWrapperClass || ''}`}
      ref={ref}
    >
      {title && (
        <div className={`${styles.title} ${'formTitle'}`}>
          <span>
            {title}
            {extraInfo && <span className={extraInfoStyle}>{extraInfo}</span>}
          </span>
          {guide && <>{RenderHelpBox(title, guide)} </>}
        </div>
      )}
      <div className={`${styles.container} `}>
        <div className={`${styles.wrapper}   ${wrapper || ''}`}>
          {prefix && <div className={`${styles.prefix} ${prefixClass}`}>{prefix}</div>}

          {value?.map((x: CheckBoxItem, j: number) => (
            <Checkbox
              wrapper={styles.singleItemWrapper}
              title={x?.title ? x?.title : null}
              key={j}
              checked={x?.checked ? true : false}
              onChange={() => onChangeCheckBox(x, j)}
            />
          ))}
          {affix && (
            <div className={`${styles.affixContainer} ${affixWrapper}`}>
              {affix && <div className={`${styles.affix} `}>{affix}</div>}
            </div>
          )}
        </div>
      </div>
      {props?.child && props?.child}
      {showError == true && <p className={`inputErrorText`}>{error}</p>}
    </div>
  );
});

//   AppInput.displayName = 'AppInput';
export default AppCheckBoxGroup;
